const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const EmptyRouterView = () => import(/* webpackChunkName: "exoty" */ '@/components/EmptyRouter.vue');
const BonusBoost = () => import(/* webpackChunkName: "bonus" */ './boost/view/edit.vue');
const BonusLoginAdd = () => import(/* webpackChunkName: "bonus" */ './login/view/add.vue');
const BonusLoginAds = () => import(/* webpackChunkName: "bonus" */ './login/view/ads.vue');
const BonusLoginEdit = () => import(/* webpackChunkName: "bonus" */ './login/view/edit.vue');
const BonusLoginList = () => import(/* webpackChunkName: "bonus" */ './login/view/index.vue');

export const ROUTE_NAME_BONUS = {
    BOOST: 'BonusBoost',
    LOGIN: {
        INDEX: 'BonusLoginList',
        ADD: 'BonusLoginAdd',
        EDIT: 'BonusLoginEdit',
        ADS: 'BonusLoginAds'
    }
} as const;

export default [
    {
        path: '/app/:appId/bonus',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: 'login',
                name: 'BonusLogin',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_BONUS.LOGIN.INDEX,
                        component: BonusLoginList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_BONUS.LOGIN.ADD,
                        component: BonusLoginAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/edit',
                        name: ROUTE_NAME_BONUS.LOGIN.EDIT,
                        component: BonusLoginEdit,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/ads',
                        name: ROUTE_NAME_BONUS.LOGIN.ADS,
                        component: BonusLoginAds,
                        meta: { requiresAuth: true }
                    }
                ]
            },
            {
                path: 'boost',
                name: ROUTE_NAME_BONUS.BOOST,
                component: BonusBoost,
                meta: { requiresAuth: true }
            }
        ]
    }
];
